import { render, staticRenderFns } from "./BaseElSelect.vue?vue&type=template&id=63001181&scoped=true"
import script from "./BaseElSelect.vue?vue&type=script&lang=js"
export * from "./BaseElSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseElSelect.vue?vue&type=style&index=0&id=63001181&prod&scoped=true&lang=css"
import style1 from "./BaseElSelect.vue?vue&type=style&index=1&id=63001181&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63001181",
  null
  
)

export default component.exports